import { BrowserRouter, Route, Routes } from "react-router-dom";

import EmailVerification from "./EmailVerification";
import ForgotPassword from "./ForgotPassword";
import Login from "./Login";
import Register from "./Register";
import ResetPassword from "./ResetPassword";

export default function Pages() {
    return (
        <>
            <BrowserRouter basename="/login">
                <Routes>
                    <Route element={<EmailVerification />} path="/email-verification" />
                    <Route element={<ForgotPassword />} path="/forgot-password" />
                    <Route element={<Register />} path="/register" />
                    <Route element={<ResetPassword />} path="/reset-password" />
                    <Route element={<Login />} path="" />
                </Routes>
            </BrowserRouter>
        </>
    );
}
